module.exports = __webpack_public_path__ + "img/horse.7301a501.png";